document.addEventListener("DOMContentLoaded", function() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  });


  $('.ha_ugc_video_start').click(function(){
    $(this).hide();
    var video = $(this).closest('.ha_ugc_video_out').find('video')[0];
      if (video) {

        video.play();
    } 
  });

  $(document).on("click",".arcf_var_cell",function() {
    // var dataId = $(this).find('.arCf_variant').attr('data-id');
    $('.cf_price_note').removeClass('active');
    $(this).closest('.arcf_var_cell').find('.cf_price_note').addClass('active');
    // setTimeout(function(){
    //   if ($('.arCf_variant[data-id="'+dataId+'"').hasClass('arCfVar_active')){
    //     console.log('should be not clciked'); 
    //   } 
    //   else{
    //     console.log('should be clciked', dataId);
    //     // $('.arCf_variant[data-id="'+dataId+'"]').trigger('click');
    //   }
    // },100);
  });


  $('.naRosebtn').click(function(){
    $('html, body').animate({
        scrollTop: $(".naProduct").offset().top-150
    }, 500);
  });


  



$(document).on("click",".md_faq_block",function() {
// $('.md_faq_block').click(function(){
  if ($(this).hasClass('active')){
      $('.md_faq_block').removeClass('active');
      $('.md_faq_block').find('.md_faq_block_content').slideUp();
  }
  else{
      $('.md_faq_block').removeClass('active');
      $('.md_faq_block').find('.md_faq_block_content').slideUp();
      $(this).find('.md_faq_block_content').slideDown();
      $(this).addClass('active');
  }
});

$('.glp_selector_cell').click(function(){
  $('.glp_selector_cell').removeClass('active');
  $(this).addClass('active');

  var data = $(this).attr('data-id');
  var isChecked = $('.arCf_toggle input').is(':checked');

  if (data == '1'){
    $('.arCf_variant[data-id="49093233639772"]').trigger('click');
    if (isChecked) {

    } else {
      $('.arCf_toggle input').trigger('click');
    }
  }
  else if (data == '2'){
    $('.arCf_variant[data-id="49093233672540"]').trigger('click');
    if (isChecked) {

    } else {
      $('.arCf_toggle input').trigger('click');
    }
  }
  else if (data == '3'){
    $('.arCf_variant[data-id="49093233705308"]').trigger('click');
    if (isChecked) {

    } else {
      $('.arCf_toggle input').trigger('click');
    }
  }
  else if (data == '4'){
    $('.arCf_variant[data-id="49093233639772"]').trigger('click');
    if (isChecked) {
      $('.arCf_toggle input').trigger('click');
    } else {
      
    }
  }
});





setTimeout(function(){
  var currentUrl = String(window.location.href);
  // if (currentUrl.indexOf('ultimate-mb-capsules') != -1){
  //   $('#subscribeAr').trigger('click');
  // }
  if (currentUrl.indexOf('/products/ultimate-methylene') != -1){
    if (currentUrl.indexOf('/products/ultimate-methylene-blue') != -1){
    }
    else{
      window.location.href = '/products/ultimate-methylene-blue';
    }
  }
},200);


// window.asl_loaded = function(){
//     // When our app loads, this function will get called.
//     var country = asl_country();
//     var countryFlag;
    
//     const countryFlags = {
//       'AX': '🇦🇽', // Åland Islands
//       'AL': '🇦🇱', // Albania
//       'DZ': '🇩🇿', // Algeria
//       'AS': '🇦🇸', // American Samoa
//       'AD': '🇦🇩', // Andorra
//       'AO': '🇦🇴', // Angola
//       'AI': '🇦🇮', // Anguilla
//       'AQ': '🇦🇶', // Antarctica
//       'AG': '🇦🇬', // Antigua and Barbuda
//       'AR': '🇦🇷', // Argentina
//       'AM': '🇦🇲', // Armenia
//       'AW': '🇦🇼', // Aruba
//       'AU': '🇦🇺', // Australia
//       'AT': '🇦🇹', // Austria
//       'AZ': '🇦🇿', // Azerbaijan
//       'BS': '🇧🇸', // Bahamas
//       'BH': '🇧🇭', // Bahrain
//       'BD': '🇧🇩', // Bangladesh
//       'BB': '🇧🇧', // Barbados
//       'BY': '🇧🇾', // Belarus
//       'BE': '🇧🇪', // Belgium
//       'BZ': '🇧🇿', // Belize
//       'BM': '🇧🇲', // Bermuda
//       'BT': '🇧🇹', // Bhutan
//       'BO': '🇧🇴', // Bolivia (Plurinational State of)
//       'BQ': '🇧🇶', // Bonaire, Sint Eustatius and Saba
//       'BA': '🇧🇦', // Bosnia and Herzegovina
//       'BW': '🇧🇼', // Botswana
//       'BV': '🇧🇻', // Bouvet Island
//       'BR': '🇧🇷', // Brazil
//       'IO': '🇮🇴', // British Indian Ocean Territory
//       'BN': '🇧🇳', // Brunei Darussalam
//       'BG': '🇧🇬', // Bulgaria
//       'BF': '🇧🇫', // Burkina Faso
//       'BI': '🇧🇮', // Burundi
//       'KH': '🇰🇭', // Cambodia
//       'CM': '🇨🇲', // Cameroon
//       'CA': '🇨🇦', // Canada
//       'KY': '🇰🇾', // Cayman Islands
//       'CL': '🇨🇱', // Chile
//       'CN': '🇨🇳', // China
//       'CX': '🇨🇽', // Christmas Island
//       'CC': '🇨🇨', // Cocos (Keeling) Islands
//       'CO': '🇨🇴', // Colombia
//       'KM': '🇰🇲', // Comoros
//       'CK': '🇨🇰', // Cook Islands
//       'CR': '🇨🇷', // Costa Rica
//       'HR': '🇭🇷', // Croatia
//       'DK': '🇩🇰', // Denmark
//       'DJ': '🇩🇯', // Djibouti
//       'DM': '🇩🇲', // Dominica
//       'DO': '🇩🇴', // Dominican Republic
//       'EC': '🇪🇨', // Ecuador
//       'EG': '🇪🇬', // Egypt
//       'SV': '🇸🇻', // El Salvador
//       'GQ': '🇬🇶', // Equatorial Guinea
//       'ER': '🇪🇷', // Eritrea
//       'EE': '🇪🇪', // Estonia
//       'ET': '🇪🇹', // Ethiopia
//       'FK': '🇫🇰', // Falkland Islands (Malvinas)
//       'FO': '🇫🇴', // Faroe Islands
//       'FJ': '🇫🇯', // Fiji
//       'FI': '🇫🇮', // Finland
//       'FR': '🇫🇷', // France
//       'GF': '🇬🇫', // French Guiana
//       'PF': '🇵🇫', // French Polynesia
//       'TF': '🇹🇫', // French Southern Territories
//       'GA': '🇬🇦', // Gabon
//       'GM': '🇬🇲', // Gambia
//       'GE': '🇬🇪', // Georgia
//       'DE': '🇩🇪', // Germany
//       'GH': '🇬🇭', // Ghana
//       'GI': '🇬🇮', // Gibraltar
//       'GR': '🇬🇷', // Greece
//       'GL': '🇬🇱', // Greenland
//       'GD': '🇬🇩', // Grenada
//       'GP': '🇬🇵', // Guadeloupe
//       'GU': '🇬🇺', // Guam
//       'GG': '🇬🇬', // Guernsey
//       'GY': '🇬🇾', // Guyana
//       'HT': '🇭🇹', // Haiti
//       'HM': '🇭🇲', // Heard Island and McDonald Islands
//       'VA': '🇻🇦', // Holy See
//       'HN': '🇭🇳', // Honduras
//       'HK': '🇭🇰', // Hong Kong
//       'HU': '🇭🇺', // Hungary
//       'IS': '🇮🇸', // Iceland
//       'IN': '🇮🇳', // India
//       'ID': '🇮🇩', // Indonesia
//       'IR': '🇮🇷', // Iran (Islamic Republic of)
//       'IQ': '🇮🇶', // Iraq
//       'IE': '🇮🇪', // Ireland
//       'IM': '🇮🇲', // Isle of Man
//       'IL': '🇮🇱', // Israel
//       'IT': '🇮🇹', // Italy
//       'JM': '🇯🇲', // Jamaica
//       'JP': '🇯🇵', // Japan
//       'JE': '🇯🇪', // Jersey
//       'JO': '🇯🇴', // Jordan
//       'KZ': '🇰🇿', // Kazakhstan
//       'KE': '🇰🇪', // Kenya
//       'KI': '🇰🇮', // Kiribati
//       'KP': '🇰🇵', // Korea (Democratic People's Republic of)
//       'KR': '🇰🇷', // Korea (Republic of)
//       'KW': '🇰🇼', // Kuwait
//       'KG': '🇰🇬', // Kyrgyzstan
//       'LA': '🇱🇦', // Lao People's Democratic Republic
//       'LV': '🇱🇻', // Latvia
//       'LB': '🇱🇧', // Lebanon
//       'LS': '🇱🇸', // Lesotho
//       'LR': '🇱🇷', // Liberia
//       'LY': '🇱🇾', // Libya
//       'LI': '🇱🇮', // Liechtenstein
//       'LT': '🇱🇹', // Lithuania
//       'LU': '🇱🇺', // Luxembourg
//       'MO': '🇲🇴', // Macao
//       'MK': '🇲🇰', // Macedonia (the former Yugoslav Republic of)
//       'MG': '🇲🇬', // Madagascar
//       'MW': '🇲🇼', // Malawi
//       'MY': '🇲🇾', // Malaysia
//       'MV': '🇲🇻', // Maldives
//       'ML': '🇲🇱', // Mali
//       'MT': '🇲🇹', // Malta
//       'MH': '🇲🇭', // Marshall Islands
//       'MQ': '🇲🇶', // Martinique
//       'MR': '🇲🇷', // Mauritania
//       'MU': '🇲🇺', // Mauritius
//       'YT': '🇾🇹', // Mayotte
//       'MX': '🇲🇽', // Mexico
//       'FM': '🇫🇲', // Micronesia (Federated States of)
//       'MD': '🇲🇩', // Moldova (Republic of)
//       'MC': '🇲🇨', // Monaco
//       'MN': '🇲🇳', // Mongolia
//       'ME': '🇲🇪', // Montenegro
//       'MS': '🇲🇸', // Montserrat
//       'MA': '🇲🇦', // Morocco
//       'MZ': '🇲🇿', // Mozambique
//       'MM': '🇲🇲', // Myanmar
//       'NA': '🇳🇦', // Namibia
//       'NR': '🇳🇷', // Nauru
//       'NP': '🇳🇵', // Nepal
//       'NL': '🇳🇱', // Netherlands
//       'NC': '🇳🇨', // New Caledonia
//       'NZ': '🇳🇿', // New Zealand
//       'NI': '🇳🇮', // Nicaragua
//       'NE': '🇳🇪', // Niger
//       'NG': '🇳🇬', // Nigeria
//       'NU': '🇳🇺', // Niue
//       'NF': '🇳🇫', // Norfolk Island
//       'MP': '🇲🇵', // Northern Mariana Islands
//       'NO': '🇳🇴', // Norway
//       'OM': '🇴🇲', // Oman
//       'PK': '🇵🇰', // Pakistan
//       'PW': '🇵🇼', // Palau
//       'PS': '🇵🇸', // Palestine, State of
//       'PA': '🇵🇦', // Panama
//       'PG': '🇵🇬', // Papua New Guinea
//       'PY': '🇵🇾', // Paraguay
//       'PE': '🇵🇪', // Peru
//       'PH': '🇵🇭', // Philippines
//       'PN': '🇵🇳', // Pitcairn
//       'PL': '🇵🇱', // Poland
//       'PT': '🇵🇹', // Portugal
//       'PR': '🇵🇷', // Puerto Rico
//       'QA': '🇶🇦', // Qatar
//       'RE': '🇷🇪', // Réunion
//       'RO': '🇷🇴', // Romania
//       'RU': '🇷🇺', // Russian Federation
//       'RW': '🇷🇼', // Rwanda
//       'BL': '🇧🇱', // Saint Barthélemy
//       'SH': '🇸🇭', // Saint Helena, Ascension and Tristan da Cunha
//       'KN': '🇰🇳', // Saint Kitts and Nevis
//       'LC': '🇱🇨', // Saint Lucia
//       'MF': '🇲🇫', // Saint Martin (French part)
//       'PM': '🇵🇲', // Saint Pierre and Miquelon
//       'VC': '🇻🇨', // Saint Vincent and the Grenadines
//       'WS': '🇼🇸', // Samoa
//       'SM': '🇸🇲', // San Marino
//       'ST': '🇸🇹', // Sao Tome and Principe
//       'SA': '🇸🇦', // Saudi Arabia
//       'SN': '🇸🇳', // Senegal
//       'RS': '🇷🇸', // Serbia
//       'SC': '🇸🇨', // Seychelles
//       'SL': '🇸🇱', // Sierra Leone
//       'SG': '🇸🇬', // Singapore
//       'SX': '🇸🇽', // Sint Maarten (Dutch part)
//       'SK': '🇸🇰', // Slovakia
//       'SI': '🇸🇮', // Slovenia
//       'SB': '🇸🇧', // Solomon Islands
//       'SO': '🇸🇴', // Somalia
//       'ZA': '🇿🇦', // South Africa
//       'GS': '🇬🇸', // South Georgia and the South Sandwich Islands
//       'SS': '🇸🇸', // South Sudan
//       'ES': '🇪🇸', // Spain
//       'LK': '🇱🇰', // Sri Lanka
//       'SD': '🇸🇩', // Sudan
//       'SR': '🇸🇷', // Suriname
//       'SJ': '🇸🇯', // Svalbard and Jan Mayen
//       'SZ': '🇸🇿', // Swaziland
//       'SE': '🇸🇪', // Sweden
//       'CH': '🇨🇭', // Switzerland
//       'SY': '🇸🇾', // Syrian Arab Republic
//       'TW': '🇹🇼', // Taiwan, Province of China
//       'TJ': '🇹🇯', // Tajikistan
//       'TZ': '🇹🇿', // Tanzania, United Republic of
//       'TH': '🇹🇭', // Thailand
//       'TL': '🇹🇱', // Timor-Leste
//       'TG': '🇹🇬', // Togo
//       'TK': '🇹🇰', // Tokelau
//       'TO': '🇹🇴', // Tonga
//       'TT': '🇹🇹', // Trinidad and Tobago
//       'TN': '🇹🇳', // Tunisia
//       'TR': '🇹🇷', // Turkey
//       'TM': '🇹🇲', // Turkmenistan
//       'TC': '🇹🇨', // Turks and Caicos Islands
//       'TV': '🇹🇻', // Tuvalu
//       'UG': '🇺🇬', // Uganda
//       'UA': '🇺🇦', // Ukraine
//       'AE': '🇦🇪', // United Arab Emirates
//       'GB': '🇬🀀򉰧, // United Kingdom of Great Britain and Northern Ireland
//       'US': '🇺🇸', // United States of America
//       'UM': '🇺🇲', // United States Minor Outlying Islands
//       'UY': '🇺🇾', // Uruguay
//       'UZ': '🇺🇿', // Uzbekistan
//       'VU': '🇻🇺', // Vanuatu
//       'VE': '🇻🇪', // Venezuela (Bolivarian Republic of)
//       'VN': '🇻🇳', // Viet Nam
//       'VG': '🇻🇬', // Virgin Islands (British)
//       'VI': '🇻🇮', // Virgin Islands (U.S.)
//       'WF': '🇼🇫', // Wallis and Futuna
//       'EH': '🇪🇭', // Western Sahara
//       'YE': '🇾🇪', // Yemen
//       'ZM': '🇿🇲', // Zambia
//       'ZW': '🇿🇼', // Zimbabwe
//   };
//     const countryNames = {
//       'AF': 'Afghanistan',
//       'AX': 'Åland Islands',
//       'AL': 'Albania',
//       'DZ': 'Algeria',
//       'AS': 'American Samoa',
//       'AD': 'Andorra',
//       'AO': 'Angola',
//       'AI': 'Anguilla',
//       'AQ': 'Antarctica',
//       'AG': 'Antigua and Barbuda',
//       'AR': 'Argentina',
//       'AM': 'Armenia',
//       'AW': 'Aruba',
//       'AU': 'Australia',
//       'AT': 'Austria',
//       'AZ': 'Azerbaijan',
//       'BS': 'Bahamas',
//       'BH': 'Bahrain',
//       'BD': 'Bangladesh',
//       'BB': 'Barbados',
//       'BY': 'Belarus',
//       'BE': 'Belgium',
//       'BZ': 'Belize',
//       'BM': 'Bermuda',
//       'BT': 'Bhutan',
//       'BO': 'Bolivia (Plurinational State of)',
//       'BQ': 'Bonaire, Sint Eustatius and Saba',
//       'BA': 'Bosnia and Herzegovina',
//       'BW': 'Botswana',
//       'BV': 'Bouvet Island',
//       'BR': 'Brazil',
//       'IO': 'British Indian Ocean Territory',
//       'BN': 'Brunei Darussalam',
//       'BG': 'Bulgaria',
//       'BF': 'Burkina Faso',
//       'BI': 'Burundi',
//       'KH': 'Cambodia',
//       'CM': 'Cameroon',
//       'CA': 'Canada',
//       'KY': 'Cayman Islands',
//       'CL': 'Chile',
//       'CN': 'China',
//       'CX': 'Christmas Island',
//       'CC': 'Cocos (Keeling) Islands',
//       'CO': 'Colombia',
//       'KM': 'Comoros',
//       'CK': 'Cook Islands',
//       'CR': 'Costa Rica',
//       'HR': 'Croatia',
//       'CU': 'Cuba',
//       'CW': 'Curaçao',
//       'CY': 'Cyprus',
//       'CZ': 'Czech Republic',
//       'DK': 'Denmark',
//       'DJ': 'Djibouti',
//       'DM': 'Dominica',
//       'DO': 'Dominican Republic',
//       'EC': 'Ecuador',
//       'EG': 'Egypt',
//       'SV': 'El Salvador',
//       'GQ': 'Equatorial Guinea',
//       'ER': 'Eritrea',
//       'EE': 'Estonia',
//       'ET': 'Ethiopia',
//       'FK': 'Falkland Islands (Malvinas)',
//       'FO': 'Faroe Islands',
//       'FJ': 'Fiji',
//       'FI': 'Finland',
//       'FR': 'France',
//       'GF': 'French Guiana',
//       'PF': 'French Polynesia',
//       'TF': 'French Southern Territories',
//       'GA': 'Gabon',
//       'GM': 'Gambia',
//       'GE': 'Georgia',
//       'DE': 'Germany',
//       'GH': 'Ghana',
//       'GI': 'Gibraltar',
//       'GR': 'Greece',
//       'GL': 'Greenland',
//       'GD': 'Grenada',
//       'GP': 'Guadeloupe',
//       'GU': 'Guam',
//       'GT': 'Guatemala',
//       'GG': 'Guernsey',
//       'GY': 'Guyana',
//       'HT': 'Haiti',
//       'HM': 'Heard Island and McDonald Islands',
//       'VA': 'Holy See',
//       'HN': 'Honduras',
//       'HK': 'Hong Kong',
//       'HU': 'Hungary',
//       'IS': 'Iceland',
//       'IN': 'India',
//       'ID': 'Indonesia',
//       'IR': 'Iran (Islamic Republic of)',
//       'IQ': 'Iraq',
//       'IE': 'Ireland',
//       'IM': 'Isle of Man',
//       'IL': 'Israel',
//       'IT': 'Italy',
//       'JM': 'Jamaica',
//       'JP': 'Japan',
//       'JE': 'Jersey',
//       'JO': 'Jordan',
//       'KZ': 'Kazakhstan',
//       'KE': 'Kenya',
//       'KI': 'Kiribati',
//       'KP': "Korea (Democratic People's Republic of)",
//       'KR': 'Korea (Republic of)',
//       'KW': 'Kuwait',
//       'KG': 'Kyrgyzstan',
//       'LA': "Lao People's Democratic Republic",
//       'LV': 'Latvia',
//       'LB': 'Lebanon',
//       'LS': 'Lesotho',
//       'LR': 'Liberia',
//       'LY': 'Libya',
//       'LI': 'Liechtenstein',
//       'LT': 'Lithuania',
//       'LU': 'Luxembourg',
//       'MO': 'Macao',
//       'MK': 'Macedonia (the former Yugoslav Republic of)',
//       'MG': 'Madagascar',
//       'MW': 'Malawi',
//       'MY': 'Malaysia',
//       'MV': 'Maldives',
//       'ML': 'Mali',
//       'MT': 'Malta',
//       'MH': 'Marshall Islands',
//       'MQ': 'Martinique',
//       'MR': 'Mauritania',
//       'MU': 'Mauritius',
//       'YT': 'Mayotte',
//       'MX': 'Mexico',
//       'FM': 'Micronesia (Federated States of)',
//       'MD': 'Moldova (Republic of)',
//       'MC': 'Monaco',
//       'MN': 'Mongolia',
//       'ME': 'Montenegro',
//       'MS': 'Montserrat',
//       'MA': 'Morocco',
//       'MZ': 'Mozambique',
//       'MM': 'Myanmar',
//       'NA': 'Namibia',
//       'NR': 'Nauru',
//       'NP': 'Nepal',
//       'NL': 'Netherlands',
//       'NC': 'New Caledonia',
//       'NZ': 'New Zealand',
//       'NI': 'Nicaragua',
//       'NE': 'Niger',
//       'NG': 'Nigeria',
//       'NU': 'Niue',
//       'NF': 'Norfolk Island',
//       'MP': 'Northern Mariana Islands',
//       'NO': 'Norway',
//       'OM': 'Oman',
//       'PK': 'Pakistan',
//       'PW': 'Palau',
//       'PS': 'Palestine, State of',
//       'PA': 'Panama',
//       'PG': 'Papua New Guinea',
//       'PY': 'Paraguay',
//       'PE': 'Peru',
//       'PH': 'Philippines',
//       'PN': 'Pitcairn',
//       'PL': 'Poland',
//       'PT': 'Portugal',
//       'PT': 'Portugal',
//       'PW': 'Palau',
//       'PS': 'Palestine, State of',
//       'PA': 'Panama',
//       'PG': 'Papua New Guinea',
//       'PY': 'Paraguay',
//       'PE': 'Peru',
//       'PH': 'Philippines',
//       'PN': 'Pitcairn',
//       'PL': 'Poland',
//       'PR': 'Puerto Rico',
//       'QA': 'Qatar',
//       'RE': 'Réunion',
//       'RO': 'Romania',
//       'RU': 'Russian Federation',
//       'RW': 'Rwanda',
//       'BL': 'Saint Barthélemy',
//       'SH': 'Saint Helena, Ascension and Tristan da Cunha',
//       'KN': 'Saint Kitts and Nevis',
//       'LC': 'Saint Lucia',
//       'MF': 'Saint Martin (French part)',
//       'PM': 'Saint Pierre and Miquelon',
//       'VC': 'Saint Vincent and the Grenadines',
//       'WS': 'Samoa',
//       'SM': 'San Marino',
//       'ST': 'Sao Tome and Principe',
//       'SA': 'Saudi Arabia',
//       'SN': 'Senegal',
//       'RS': 'Serbia',
//       'SC': 'Seychelles',
//       'SG': 'Singapore',
//       'SX': 'Sint Maarten (Dutch part)',
//       'SK': 'Slovakia',
//       'SI': 'Slovenia',
//       'SB': 'Solomon Islands',
//       'SO': 'Somalia',
//       'ZA': 'South Africa',
//       'GS': 'South Georgia and the South Sandwich Islands',
//       'SS': 'South Sudan',
//       'ES': 'Spain',
//       'LK': 'Sri Lanka',
//       'SD': 'Sudan',
//       'SR': 'Suriname',
//       'SJ': 'Svalbard and Jan Mayen',
//       'SZ': 'Swaziland',
//       'SE': 'Sweden',
//       'CH': 'Switzerland',
//       'SY': 'Syrian Arab Republic',
//       'TW': 'Taiwan, Province of China',
//       'TJ': 'Tajikistan',
//       'TZ': 'Tanzania, United Republic of',
//       'TH': 'Thailand',
//       'TL': 'Timor-Leste',
//       'TG': 'Togo',
//       'TK': 'Tokelau',
//       'TO': 'Tonga',
//       'TT': 'Trinidad and Tobago',
//       'TN': 'Tunisia',
//       'TR': 'Turkey',
//       'TM': 'Turkmenistan',
//       'TC': 'Turks and Caicos Islands',
//       'TV': 'Tuvalu',
//       'UG': 'Uganda',
//       'UA': 'Ukraine',
//       'AE': 'United Arab Emirates',
//       'GB': 'United Kingdom of Great Britain and Northern Ireland',
//       'US': 'United States of America',
//       'UM': 'United States Minor Outlying Islands',
//       'UY': 'Uruguay',
//       'UZ': 'Uzbekistan',
//       'VU': 'Vanuatu',
//       'VE': 'Venezuela (Bolivarian Republic of)',
//       'VN': 'Viet Nam',
//       'VG': 'Virgin Islands (British)',
//       'VI': 'Virgin Islands (U.S.)',
//       'WF': 'Wallis and Futuna',
//       'EH': 'Western Sahara',
//       'YE': 'Yemen',
//       'ZM': 'Zambia',
//       'ZW': 'Zimbabwe',  
//     };

    
//     if (countryFlags.hasOwnProperty(country)) {
//       countryFlag = countryFlags[country];
//     }

//     if (countryNames.hasOwnProperty(country)) {
//       country = countryNames[country];
//     }

//     $('.shippingTo_js').text(country +' '+countryFlag);
//     console.log(country, 'CUSTOMER COUNTRY');
// }




